/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  CancellationPolicies,
  CancellationPoliciesFormValues,
} from './policies.types'
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import fetcher from '@/core/lib/fetcher'
import { APIError, APIResponse } from '@/core/types/utils'
import { toast } from '@/core/components/ui/use-toast'

export const cancellationPoliciesQueryOptions = (
  siteId: string,
  token: string
) =>
  queryOptions({
    queryKey: ['cancellationPolicies', siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(
          import.meta.env.VITE_API_BOOKING +
            `property/${siteId}/cancellation-policy`
        )
        .json<Promise<APIResponse<CancellationPolicies[]>>>(),
  })

export const createCancellationPolicy = (
  data: CancellationPoliciesFormValues,
  siteId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(
      import.meta.env.VITE_API_BOOKING +
        `property/${siteId}/cancellation-policy`
    )
    .post(data)
    .json()

export const updateCancellationPolicy = (
  data: CancellationPoliciesFormValues,
  policyId: string,
  token: string
) =>
  fetcher
    .auth(`Bearer ${token}`)
    .url(
      import.meta.env.VITE_API_BOOKING +
        `property/cancellation-policy/${policyId}`
    )
    .put(data)
    .json<Promise<APIResponse<CancellationPolicies>>>()

export const getCancellationPolicyById = (policyId: string, token: string) =>
  queryOptions({
    queryKey: ['cancellationPolicy', policyId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .url(
          import.meta.env.VITE_API_BOOKING +
            `property/cancellation-policy/${policyId}`
        )
        .get()
        .json<Promise<APIResponse<CancellationPolicies>>>(),
  })

export const useDeleteCancellationPolicy = (token: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (policyId: string) =>
      fetcher
        .auth(`Bearer ${token}`)
        .url(
          import.meta.env.VITE_API_BOOKING +
            `property/cancellation-policy/${policyId}`
        )
        .delete()
        .json(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['cancellationPolicies'],
      })
            void queryClient.invalidateQueries({
        queryKey: ['rates'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['rate'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['package'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['packages'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['activities'],
      })
      void queryClient.invalidateQueries({
        queryKey: ['activity'],
      })
    },
    onError: (error) => {
      const errorObject: APIError<null> = JSON.parse(error.message)
      const errorMessage = errorObject.message

      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      })
    },
  })
}
